export const
COMPLAINT_POSITION_UPDATE_FIELD="COMPLAINT_POSITION_UPDATE_FIELD",
COMPLAINT_POSITION_ADD_FILE = "COMPLAINT_POSITION_ADD_FILE",
COMPLAINT_POSITION_CHANGE_AMOUNT = "COMPLAINT_POSITION_CHANGE_AMOUNT",
COMPLAINT_POSITION_CHANGE_ARTICLE_SERIAL_NUMBER = "COMPLAINT_POSITION_CHANGE_ARTICLE_SERIAL_NUMBER",
COMPLAINT_POSITION_CHANGE_ARTICLE_PURCHASE_DATE = "COMPLAINT_POSITION_CHANGE_ARTICLE_PURCHASE_DATE",
COMPLAINT_POSITION_CHANGE_COURIER = "COMPLAINT_POSITION_CHANGE_COURIER",
COMPLAINT_POSITION_CHANGE_CUSTOMER_REQUEST = "COMPLAINT_POSITION_CHANGE_CUSTOMER_REQUEST",
COMPLAINT_POSITION_CHANGE_DATE_OF_RECEIPT_OF_GOODS = "COMPLAINT_POSITION_CHANGE_DATE_OF_RECEIPT_OF_GOODS",
COMPLAINT_POSITION_CHANGE_NOTES = "COMPLAINT_POSITION_CHANGE_NOTES",
COMPLAINT_POSITION_CHANGE_FAULT_DATE = "COMPLAINT_POSITION_CHANGE_FAULT_DATE",
COMPLAINT_POSITION_CHANGE_FAULT_DESCRIPTION = "COMPLAINT_POSITION_CHANGE_FAULT_DESCRIPTION",
COMPLAINT_POSITION_CHANGE_FAULT_DISCOVERY_CIRCUMSTANCES = "COMPLAINT_POSITION_CHANGE_FAULT_DISCOVERY_CIRCUMSTANCES",
COMPLAINT_POSITION_CHANGE_INVOICE_QUANTITY = "COMPLAINT_POSITION_CHANGE_INVOICE_QUANTITY",
COMPLAINT_POSITION_CHANGE_PRODUCT = "COMPLAINT_POSITION_CHANGE_PRODUCT",
COMPLAINT_POSITION_CHANGE_QUANTITY_CORRECTIONS_PROPOSAL = "COMPLAINT_POSITION_CHANGE_QUANTITY_CORRECTIONS_PROPOSAL",
COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_NUMBER = "COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_NUMBER",
COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_POSITION = "COMPLAINT_POSITION_CHANGE_SALES_DOCUMENT_POSITION",
COMPLAINT_POSITION_CHANGE_SHIPMENT_DESCRIPTION = "COMPLAINT_POSITION_CHANGE_SHIPMENT_DESCRIPTION",
COMPLAINT_POSITION_CHANGE_SHIPPED_QUANTITY = "COMPLAINT_POSITION_CHANGE_SHIPPED_QUANTITY",
COMPLAINT_POSITION_CHANGE_TERM_OF_USE = "COMPLAINT_POSTION_CHANGE_TERM_OF_USE",
COMPLAINT_POSITION_FILL_BY_OBJECT = "COMPLAINT_POSITION_FILL_BY_OBJECT",
COMPLAINT_POSITION_REMOVE_FILE = "COMPLAINT_POSITION_REMOVE_FILE",
ADD_PURCHASE_ADDRESS_TO_COMPLAINT_POSITION = "ADD_PURCHASE_ADDRESS_TO_COMPLAINT_POSITION",
COMPLAINT_POSITION_DISSMIS_CHANGES = "COMPLAINT_POSITION_DISSMIS_CHANGES";




// WEBPACK FOOTER //
// ./src/types/ComplaintPosition.js